import { useTheme, Theme } from 'cs-kevlar-react/lib/es/theming/theme'
import useMediaQuery from '@mui/material/useMediaQuery'

export type FormFactors = {
  isPhone: boolean
  isTabletOrSmaller: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const useFormFactor: () => FormFactors = () => {
  const theme = useTheme<Theme>()
  const isXSmall = useMediaQuery(theme.breakpoints.only('xs'))
  const isSmall = useMediaQuery(theme.breakpoints.only('sm'))
  const isMedium = useMediaQuery(theme.breakpoints.only('md'))
  const isLarge = useMediaQuery(theme.breakpoints.only('lg'))
  const isXLarge = useMediaQuery(theme.breakpoints.only('xl'))

  const isPhone = isXSmall
  const isTablet = (isSmall || isMedium) && !isLarge
  const isDesktop = isLarge || isXLarge

  return {
    isPhone,
    isTabletOrSmaller: isPhone || isTablet,
    isTablet,
    isDesktop,
  }
}
